import React from 'react';
import { User as UserIcon, Shield, Paperclip } from 'lucide-react';
import { supportAttachmentHref } from '../../utils/supportAttachmentHref';
import { formatSupportSenderLabel, isOwnTicketMessage } from '../../utils/supportSenderLabel';

export function SupportMessageBubble({ msg, ticketRef, ticket, theme = 'b2c' }) {
  const isAdmin = msg.sender_type === 'admin';
  const pending = Boolean(msg._pending);
  const isSelf = isOwnTicketMessage(msg, ticket);
  const label = formatSupportSenderLabel(msg, { view: 'customer', isSelf });

  const adminAvatar = theme === 'agent' ? 'bg-teal-100 text-teal-700' : 'bg-blue-100 text-blue-600';
  const selfAvatar = theme === 'agent' ? 'bg-[#1B375B]/10 text-[#1B375B]' : 'bg-orange-100 text-orange-600';
  const selfBubble = theme === 'agent' ? 'bg-teal-50 text-gray-900' : 'bg-blue-50 text-gray-900';
  const linkClass = theme === 'agent' ? 'text-teal-700' : 'text-blue-600';

  return (
    <div className={`flex gap-3 ${isAdmin ? '' : 'flex-row-reverse'} ${pending ? 'opacity-60' : ''}`}>
      <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
        isAdmin ? adminAvatar : selfAvatar
      }`}>
        {isAdmin ? <Shield className="w-4 h-4" /> : <UserIcon className="w-4 h-4" />}
      </div>
      <div className={`flex-1 max-w-[78%] ${isAdmin ? '' : 'text-right'}`}>
        <div className="text-[10px] text-gray-500 mb-0.5">
          <strong className="text-gray-900">{label}</strong>
          <span className="mx-1">·</span>
          <span>{new Date(msg.created_at).toLocaleString()}</span>
        </div>
        <div className={`inline-block text-sm rounded-lg p-3 whitespace-pre-wrap ${
          isAdmin ? 'bg-gray-100 text-gray-900' : selfBubble
        }`}>
          {msg.message}
          {msg.attachments?.length > 0 && (
            <div className="mt-2 space-y-1 text-left">
              {msg.attachments.map((a, i) => (
                <a
                  key={i}
                  href={supportAttachmentHref(ticketRef, a.url, false)}
                  target="_blank"
                  rel="noreferrer"
                  className={`block text-xs hover:underline flex items-center gap-1 ${linkClass}`}
                >
                  <Paperclip className="w-3 h-3" /> {a.filename}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SupportMessageBubble;
